module.exports = __webpack_public_path__ + "assets/img/kv-315306db.png";